import React from 'react';
import { PLUGIN_TOOLBAR_BUTTON_ID, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { selectedNodeResolver, getVisibleOnlyOnDesktopResolver } from 'wix-rich-content-plugin-commons';
import { SizePanel, NodeSizeButton, AlignmentPanel, NodeAlignmentButton } from 'wix-rich-content-toolbars-ui';
import { audioModals, AUDIO_BUTTONS } from './consts.js';
import InsertModal from './modals/InsertModal.js';
import AudioSettingsModal from './modals/SettingsModal.js';
import AudioEditButton from './toolbar/AudioEditButton.js';
import 'ricos-types';
import 'ricos-content';
import 'ricos-context';
import './modals/AudioInsertModal.js';
import 'classnames';
import 'react-player';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './dataHooks.js';
import './modals/AudioUploadModal.js';
import './toolbar/audioPluginService.js';
import 'lodash';
import './modals/MediaURLInputModal.js';
import './modals/utils.js';
import './modals/AudioSettings.js';
import 'wix-rich-content-common/libs/imageUtils';

const isCustomAudioResolver = {
  id: "isCustomAudio",
  resolve: (content) => {
    var _a, _b, _c;
    if (Array.isArray(content) && content.length > 0) {
      return !!((_c = (_b = (_a = content[0].attrs) == null ? void 0 : _a.audio) == null ? void 0 : _b.src) == null ? void 0 : _c.id);
    } else {
      return false;
    }
  }
};
const getToolbarButtons = (config, services) => {
  const { getAudioUrl, fetchData } = config || {};
  const {
    modals,
    context: { isMobile }
  } = services;
  return [
    {
      id: audioModals.settings,
      dataHook: "baseToolbarButton_settings",
      modal: {
        Component: AudioSettingsModal,
        id: audioModals.settings
      },
      attributes: {
        visible: isCustomAudioResolver,
        selectedNode: selectedNodeResolver
      },
      command: ({ isMobile: isMobile2, attributes: { selectedNode } }) => {
        modals == null ? void 0 : modals.openModal(audioModals.settings, {
          componentProps: {
            nodeId: selectedNode.attrs.id,
            handleFileSelection: config.handleFileSelection,
            handleFileUpload: config.handleFileUpload
          },
          positioning: { placement: "right" },
          layout: isMobile2 ? "fullscreen" : "drawer"
        });
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(AudioEditButton, { toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: isCustomAudioResolver,
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SIZE,
      modal: {
        Component: decorateComponentWithProps(SizePanel, {
          options: ["SMALL", "CONTENT"]
        }),
        id: AUDIO_BUTTONS.size
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeSizeButton, { id: AUDIO_BUTTONS.size, toolbarItem })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: AUDIO_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: AUDIO_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR,
      attributes: {
        visible: getVisibleOnlyOnDesktopResolver(isMobile)
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.REPLACE,
      modal: {
        Component: decorateComponentWithProps(InsertModal, { modalId: audioModals.replace }),
        id: audioModals.replace
      },
      command: ({ isMobile: isMobile2, referenceElement, attributes: { selectedNode } }) => {
        const {
          audio: { src },
          id
        } = selectedNode.attrs;
        if (modals.isModalOpen(audioModals.replace)) {
          modals.closeModal(audioModals.replace);
        } else {
          modals.openModal(audioModals.replace, {
            componentProps: {
              componentData: selectedNode.attrs,
              //TODO: convert to draft
              nodeId: id,
              getAudioUrl,
              handleFileSelection: config.handleFileSelection,
              handleFileUpload: config.handleFileUpload,
              fetchData,
              embedType: src.url
            },
            positioning: { placement: "bottom", referenceElement },
            layout: isMobile2 ? "fullscreen" : "popover"
          });
        }
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
